import { NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { NzButtonModule } from 'ng-zorro-antd/button';

@Component({
  selector: 'adspt-alerts-no-data',
  templateUrl: './alerts-no-data.component.html',
  styleUrls: ['./alerts-no-data.component.scss'],
  imports: [TranslateModule, NzButtonModule, NgIf],
})
export class AlertsNoDataComponent {
  @Input()
  hasFilters = false;

  @Input()
  compact = false;
}
